import React, { useEffect, useState } from "react";
import general from "../../../general";
import { Link } from "react-router-dom";
import $ from "jquery";
import { useUpdateEffect, useScroll } from "ahooks";
import Dialog from "../../../lib/Dialog";
import Image from "../../../lib/Image";
import { splitStr } from "../../../utils/commonFunc";

export default (props) => {
  const [init, setInit] = useState();
  const [loading, setLoading] = useState();
  const [page, setPage] = useState(1);
  const [games, setGames] = useState([]);
  const [more, setMore] = useState(true);
  const load = (parms = {}) => {
    if (loading) {
      return;
    }
    setLoading(true);
    Dialog.loading();
    let tmp = {
      pagination: { page: page, count: 50 },
    };
    if (parms.page) {
      tmp.pagination = { page: parms.page };
    }
    general.axios
      .post("/v3/collectedGames", tmp)
      .finally(() => {
        setLoading(false);
        Dialog.close();
      })
      .then((response) => {
        setInit(true);
        let result = response.data.data;
        if (parms.page) {
          setPage(parms.page);
        }
        setGames((games) =>
          parms.page === 1 || !parms.page
            ? result.game_list
            : [...games, ...result.game_list]
        );
        setMore(result.paginated.more);
      })
      .catch((error) => {
        Dialog.error(error.message);
      });
  };
  useEffect(() => {
    if (props.active && !init) {
      load();
    }
  }, [props.active]);
  useUpdateEffect(() => {
    if (props.active && (!init || props.action === "POP")) {
      load();
    }
  }, [props]);

  const scroll = useScroll();
  useEffect(() => {
    if (props.active && init) {
      if (scroll?.top < -80) {
        load({ page: 1 });
      }
      if (
        scroll?.top + window.innerHeight + 20 > $(document).height() &&
        more
      ) {
        load({ page: page + 1 });
      }
    }
  }, [scroll, props.active]);

  return (
    <>
      {games.length > 0 ? (
        <div className="favorite-game" style={{ padding: "10px" }}>
          {games.map((game) => (
            <Link
              key={game.game_id}
              to={"/game?id=" + game.game_id}
              className="game-list-global-type"
              style={{ padding: "10px 0 10px 10px" }}
            >
              <div className="game-list-global-type-left">
                <div className="icon">
                  <Image src={game?.game_image?.thumb} />
                </div>

                <div className="data">
                  <div className="name">
                    <div className="name-main">
                      {game.game_name_main || game.game_name}
                    </div>

                    {game?.game_tags?.is_special_server_game == 2 && (
                      <div className="dedicated-server">专服</div>
                    )}
                  </div>

                  <div className="desc">
                    {splitStr(game.game_classify_type)}
                    {game.game_name_branch && (
                      <>
                        <div className="circle"></div>
                        {game.game_name_branch}
                      </>
                    )}
                  </div>

                  <div className="info">
                    {game.game_desc && (
                      <>
                        {game?.is_trial_game == 2 ? (
                          <>
                            <div className="play-tag">有奖试玩</div>
                            {game.game_desc
                              ?.split("+")
                              .slice(0, 1)
                              .map((item, index) => (
                                <div key={index} className="tag">
                                  {item}
                                </div>
                              ))}
                          </>
                        ) : (
                          game.game_desc
                            ?.split("+")
                            .slice(0, 2)
                            .map((item, index) => (
                              <div key={index} className="tag">
                                {item}
                              </div>
                            ))
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>

              {game?.game_tags?.is_premium_game == 2 ? (
                <div
                  className="is-premium"
                  style={{
                    backgroundImage: "url('/resources/common/boutique.png')",
                  }}
                >
                  {game.discount < 1 ? (
                    <p className="is-premium-discount">
                      {parseFloat((game.discount * 10).toFixed(2))}折
                    </p>
                  ) : null}
                  <p className="boutique">精品游戏</p>
                </div>
              ) : game?.game_tags?.is_free_version == 2 ? (
                <div className="is-free-version">
                  <span>免费版</span>
                </div>
              ) : (
                <>
                  {game.discount < 1 ? (
                    <div className="discount">
                      {parseFloat((game.discount * 10).toFixed(2))}折
                    </div>
                  ) : null}
                </>
              )}
            </Link>
          ))}
          {games.length > 0 && !more ? (
            <div className="view-end">别撩啦！已经到底啦~</div>
          ) : null}
        </div>
      ) : (
        <>
          {init && !games.length ? (
            <div className="ug-empty" style={{ paddingTop: "200px" }}>
              <img style={{ width: "70%" }} src="/resources/empty.png" alt="" />
              <p>暂无收藏游戏</p>
            </div>
          ) : null}
        </>
      )}
    </>
  );
};
